import React, { useState, useEffect } from "react";
import { logo } from "../Assets";


const Navbar = () => {
  const [scrolling, setScrolling] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Listen for scroll events to toggle background color
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    // Attach scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`w-full fixed z-30 top-0 left-0 transition-all duration-300 ${
          scrolling ? "bg-black" : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <a href="/" className="flex items-center space-x-3 text-2xl text-white">
              <img src={logo} alt="Logo" className="w-48" />
            </a>

            {/* Desktop Buttons */}
            <div className="hidden md:flex items-center space-x-6">
              <a
                href="https://t.me/nadstradebot"
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-2 rounded-lg bg-[#F458FF] text-white font-semibold hover:opacity-90 transition"
              >
                Start Trading
              </a>

              <div className="relative group">
                <button className="px-6 py-2 rounded-lg bg-white text-black font-semibold hover:opacity-90 transition">
                  Menu
                </button>
                {/* Dropdown */}
                <div className="absolute right-0 mt-2 w-48 bg-white text-black rounded-lg shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-all duration-300 z-50">
                  <a href="#about" className="block px-4 py-2 hover:bg-gray-200">About</a>
                  <a href="#features" className="block px-4 py-2 hover:bg-gray-200">Features</a>
                  <a href="#how-it-works" className="block px-4 py-2 hover:bg-gray-200">How It Works</a>
                  <a href="#why-nad" className="block px-4 py-2 hover:bg-gray-200">Why NTB?</a>
                  <a href="#faq" className="block px-4 py-2 hover:bg-gray-200">FAQ</a>
                </div>
              </div>
            </div>

            {/* Mobile Menu */}
            <div className="md:hidden flex items-center">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-white focus:outline-none"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d={
                      isMenuOpen
                        ? "M6 18L18 6M6 6l12 12"
                        : "M4 6h16M4 12h16M4 18h16"
                    }
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile Sliding Full-Screen Menu */}
          <div
            className={`fixed inset-0 bg-black bg-opacity-95 text-white flex flex-col items-center justify-center space-y-6 transform transition-transform duration-500 ease-in-out ${
              isMenuOpen ? "translate-x-0" : "translate-x-full"
            } md:hidden`}
          >
            <a
              href="https://t.me/NadsTradingBot"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-2 rounded-lg bg-[#F458FF] text-white font-semibold hover:opacity-90 transition"
              onClick={() => setIsMenuOpen(false)}
            >
              Start Trading
            </a>

            <div className="w-full max-w-xs">
              <button className="w-full px-6 py-2 rounded-lg bg-white text-black font-semibold focus:outline-none mb-2">
                Links
              </button>
              <div className="flex flex-col space-y-2">
                <a href="#about" className="block px-4 py-2 hover:bg-gray-200" onClick={() => setIsMenuOpen(false)}>About</a>
                <a href="#features" className="block px-4 py-2 hover:bg-gray-200" onClick={() => setIsMenuOpen(false)}>Features</a>
                <a href="#how-it-works" className="block px-4 py-2 hover:bg-gray-200" onClick={() => setIsMenuOpen(false)}>How It Works</a>
                <a href="#why-nad" className="block px-4 py-2 hover:bg-gray-200" onClick={() => setIsMenuOpen(false)}>Why Nad</a>
                <a href="#faq" className="block px-4 py-2 hover:bg-gray-200" onClick={() => setIsMenuOpen(false)}>FAQ</a>
              </div>
            </div>

            <button
              onClick={() => setIsMenuOpen(false)}
              className="absolute top-6 right-6 text-white text-3xl focus:outline-none"
            >
              ×
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;